import axiosInstance from 'apis/axiosInstance';
import noti from 'libs/notification';

export const getMe = async (token: string) => {
  try {
    const response = await axiosInstance.get('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    noti('error','Error fetching user data:');
    throw error;
  }
};
